// extracted by mini-css-extract-plugin
module.exports = {"paperContainer":"Reports_paperContainer__1jEcX","title":"Reports_title__2Mgmn","innerContainer":"Reports_innerContainer__2WHsB","filterLabel":"Reports_filterLabel__1k6jo"};